import React, { useEffect, useState, useContext } from "react";
import "./ForgotPassword.css";
import { MyContext } from "../../../../Context/MyContext";
import API from "../../../../Api/api";
import { toast } from "react-toastify";
import OtpModal from "./OtpModal";

const ForgotPassword = ({ setActiveTab }) => {
  const { logininput } = useContext(MyContext);
  const safeForgot = logininput?.forgot_password || [];

  const [formData, setFormData] = useState({ phone: "", email: "" });
  const [otpModal, setOtpModal] = useState(false);
  const [otpPin,   setOtpPin]   = useState("");
  const [sending,  setSending]  = useState(false);
  const [verified, setVerified] = useState({ email: false, phone: false });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const sendOtp = async () => {
    const email = formData.email;
    if (!email) { toast.error("Please enter email!"); return; }
    setSending(true);
    try {
      const res = await API.post('/auth/send-otp', { email, purpose: 'forgot' });
      if (res.data.otp_dev) {
        setOtpPin(res.data.otp_dev);
        toast.info(`Dev OTP: ${res.data.otp_dev}`);
      } else {
        setOtpPin("");
        toast.success(`OTP sent to ${email}`);
      }
      setOtpModal(true);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to send OTP");
    } finally { setSending(false); }
  };

  // After OTP verified → save email + go to reset
  useEffect(() => {
    if (verified.forgot || verified.email) {
      localStorage.setItem('reset_email', formData.email);
      setTimeout(() => setActiveTab("reset_password"), 300);
    }
  }, [verified]); // eslint-disable-line

  const handleSubmit = (e) => {
    e.preventDefault();
    sendOtp();
  };

  return (
    <div className="forgot-container">
      <form className="forgot-form" onSubmit={handleSubmit}>
        <h2 className="forgot-title">Forgot Password</h2>
        <p className="forgot-subtitle">Enter your email to receive OTP.</p>
        {safeForgot.filter(i => i.field !== "otp" && i.is_show && i.field === "email").map(item => (
          <div className="input-group" key={item.id}>
            <label>{item.name}</label>
            <input type={item.type} name={item.field}
              value={formData[item.field] || ""} onChange={handleChange} placeholder={item.name}/>
          </div>
        ))}
        <button type="submit" className="forgot-btn" disabled={sending}>
          {sending ? "Sending OTP…" : "Continue"}
        </button>
        <p className="back-login-text">Back to <span onClick={() => setActiveTab("login")}>Login</span></p>
      </form>

      <OtpModal
        otpModal={otpModal}
        setOtpModal={setOtpModal}
        otpType="forgot"
        otpPin={otpPin}
        setVerified={setVerified}
        email={formData.email}
        onResend={sendOtp}
      />
    </div>
  );
};

export default ForgotPassword;